export default new class {
	addGA() {
		if (window.gtag || !window.GA_TRACKING_ID) return;
		console.log('Activating Google Analytics...');
		window.dataLayer = window.dataLayer || [];
		window.gtag = () => { dataLayer.push(arguments); }
		window.gtag('js', new Date());
		window.gtag('config', window.GA_TRACKING_ID);
	}

	sendButtonEvent(action, label) {
		if (window.gtag) {
			gtag('event', action, {
				'event_category': 'UI button click',
				'event_label': label,
			});
		}
	}

	sendErrorEvent(action, label) {
		if (window.gtag) {
			gtag('event', action, {
				'event_category': 'UI error',
				'event_label': label,
			});
		}
	}
};
